import React, { useState } from 'react'
import { staticImgsEditor } from './Constants'
import './styles/image-uploader.scss'
import { Spin, Upload } from 'antd'
import { useFileUploadMutation } from 'api/FileUpload/FileUpload'
import { webContentStore } from 'state/setting/webContent'
import { Photo } from 'types/globalTypes'
import { X } from '@phosphor-icons/react'
import heic2any from 'heic2any'
import { infoMessage } from 'api/global'

const ImageUploaderCont: React.FC = () => {
  const [imageStates, setImageStates] = useState<{
    [key: number]: {
      id?: string
      photo?: Photo
    }
  }>({})

  const {
    updateSlideContent,
    setGalleryId,
    setGalleryPhoto,
    slides,
    currentSlide,
  } = webContentStore()

  console.log(slides, 'these are slides....')

  const setImageId = (imgIndex: number, id: string | undefined) => {
    setImageStates(prev => ({
      ...prev,
      [imgIndex]: { ...(prev[imgIndex] || {}), id },
    }))
    // reflect in preview store so WebContent shows it immediately
    setGalleryId(imgIndex, id)
  }

  const setImagePhoto = (imgIndex: number, photo: Photo | undefined) => {
    setImageStates(prev => ({
      ...prev,
      [imgIndex]: { ...(prev[imgIndex] || {}), photo },
    }))
    // reflect in preview store so WebContent shows it immediately
    setGalleryPhoto(imgIndex, photo)
  }

  const getImageId = (imgIndex: number) => imageStates[imgIndex]?.id
  const getImagePhoto = (imgIndex: number) => imageStates[imgIndex]?.photo

  const [uploading, setUploading] = useState(false)
  const { mutate: fileUploadMutation } = useFileUploadMutation()

  const handleDeleteImage = (event, imgIndex: number) => {
    event.stopPropagation()
    setImageId(imgIndex, undefined)
    setImagePhoto(imgIndex, undefined)

    // update gallery
    const updatedGallery = [...slides[currentSlide].gallery]
    const updatedGalleryIds = [...slides[currentSlide].galleryIds]
    updatedGalleryIds[imgIndex] = {
      imageIndex: imgIndex,
      imageId: undefined,
    }
    updatedGallery[imgIndex] = ''
    updateSlideContent(slides[currentSlide].id, {
      ...slides[currentSlide]?.content,
      gallery: updatedGallery,
      galleryIds: updatedGalleryIds,
    })
  }

  const updateSlideImage = (imgIndex: number, file: any) => {
    setImagePhoto(imgIndex, file.uploadResult)
    setImageId(imgIndex, file.id)

    const updatedGallery = [...slides[currentSlide].gallery]
    updatedGallery[imgIndex] = file.uploadResult.original
    const updatedGalleryIds = [...slides[currentSlide].galleryIds]

    updatedGalleryIds[imgIndex] = {
      imageIndex: imgIndex,
      imageId: file.id,
    }

    updateSlideContent(slides[currentSlide]?.id, {
      ...slides[currentSlide].content,
      gallery: updatedGallery,
      galleryIds: updatedGalleryIds,
    })
  }

  const handleChangeImage = async (info: any, imgIndex: number) => {
    const fileObj = new FormData()
    setUploading(true)
    if (
      info.file.originFileObj.type === 'image/heic' ||
      info.file.originFileObj.name.endsWith('.heic')
    ) {
      try {
        const blob = await heic2any({
          blob: info.file.originFileObj,
          toType: 'image/jpeg',
          quality: 0.9,
        })
        const jpegFile = new File(
          [blob] as any,
          info.file.originFileObj.name.replace(/\.heic$/i, '.jpeg'),
          {
            type: 'image/jpeg',
          },
        )
        fileObj.append('file', jpegFile)
      } catch (err) {
        infoMessage('HEIC conversion failed')
        return
      }
    } else {
      fileObj.append('file', info.file.originFileObj)
    }

    let newFile = {
      title: info?.file.name || 'image',
      description: 'hero_image',
      altText: 'iamge',
      sourceType: 'other',
    }

    fileUploadMutation(
      { payload: fileObj, newFile },
      {
        onSuccess: (fileSuccessData: any) => {
          // setImagePhoto(imgIndex, fileSuccessData.uploadResult)
          // setImageId(imgIndex, fileSuccessData.id)
          updateSlideImage(imgIndex, fileSuccessData)
          setUploading(false)
        },
        onError: (error: any) => {
          setUploading(false)
        },
      },
    )
  }

  return (
    <>
      {uploading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
          }}
        >
          <Spin size="large" />
        </div>
      )}
      <div className={`carousel_gallery_uploader`}>
        {staticImgsEditor.map((staticImg, i) => {
          return (
            <Upload
              accept={'image/*'}
              multiple={false}
              maxCount={1}
              showUploadList={false}
              beforeUpload={file => {
                handleChangeImage(
                  { file: { originFileObj: file, name: file.name } },
                  i,
                )
                return false
              }}
            >
              <div
                className={`image_uploader_item ${[
                  `image_uploader_item_${i + 1}`,
                ]}`}
              >
                <div
                  className={`static_img ${[`static_img_${i + 1}`]}
                            }`}
                >
                  <img
                    width={300}
                    height={300}
                    src={staticImg}
                    alt="img-content"
                    style={{ width: '100%', height: '100%' }}
                  />
                  {(() => {
                    // const overlaySrc =
                    //   getImagePhoto(i)?.thumb || getImagePhoto(i)?.original || ''
                    const overlaySrc = slides[currentSlide]?.gallery[i]
                    return overlaySrc && overlaySrc.trim().length > 0 ? (
                      <div className={`overlay_image`}>
                        <img
                          width={300}
                          height={300}
                          src={overlaySrc}
                          alt="img-content"
                          className={`${[`overlay_image_${i + 1}`]}`}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectPosition: 'center',
                          }}
                        />
                        <button
                          className="btn-cross"
                          onClick={e => handleDeleteImage(e, i)}
                        >
                          <X size={20} color="#000" />
                        </button>
                      </div>
                    ) : null
                  })()}
                </div>
              </div>
            </Upload>
          )
        })}
      </div>
    </>
  )
}

export default ImageUploaderCont
